import * as z from 'zod';

export const StudentTypesSchema = z.object({
    "id": z.number(),
    "is_active": z.boolean(),
    "name": z.string()
});

export const StudentTypesPartialSchema = StudentTypesSchema.partial();
export type StudentTypesPartial = z.infer<typeof StudentTypesPartialSchema>;
export type StudentTypes = z.infer<typeof StudentTypesSchema>;

export function newStudentTypes(data: unknown) {
    if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }

    if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }

    return {
        ...StudentTypesSchema.parse({...data})
    };
}

export function parseStudentTypes(data: any, partial = false) {
    if (!partial) {
        return {
            ...StudentTypesSchema.parse(data)
        };
    }
    else if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }
    else if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }
    else if (Object.keys(data).length === 0) {
        throw new Error('Payload Object can\'t be null');
    }
    else {
        return {
            ...StudentTypesPartialSchema.parse(data)
        };
    }
}
